/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "../Home/Home.css";

// import required modules
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import UpperFooterSlider from "../../Layout/Upper Footer Slider/UpperFooterSlider";
import HomeProducts from "./HomeProducts";

export default function Home() {
  const [swiper, setSwiper] = useState(null);
  const swiperRef = useRef(null);

  return (
    <div>
      <main>
        {/* hero-area-start */}
        {/* <div className="tp-hero-2__wrapper fix p-relative">
          <div className="tp-hero-2__area">
            <div
              className="tp-hero-2__bg p-relative right-bg"
             
              style={{
                backgroundSize: "cover",
                backgroundImage:
                  "url('assets/img/breadcrumb/Homepage-slide.png')",
              }}
            >
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div
                      id="robotcarousel"
                      className="carousel slide"
                      data-bs-ride="carousel"
                    >
                      <div className="carousel-indicators">
                        <button
                          type="button"
                          data-bs-target="#robotcarousel"
                          data-bs-slide-to={0}
                          className="active"
                          aria-current="true"
                          aria-label="Slide 1"
                        />
                        <button
                          type="button"
                          data-bs-target="#robotcarousel"
                          data-bs-slide-to={1}
                          aria-label="Slide 3"
                        />
                        <button
                          type="button"
                          data-bs-target="#robotcarouse1"
                          data-bs-slide-to={2}
                          aria-label="Slide 3"
                        />
                      </div>
                      <div className="carousel-inner">
                        <div className="carousel-item">
                          <div className="tp-hero-2__wrapper fix p-relative">
                            <div className="tp-hero-2__area">
                              <div
                                className="tp-hero-2__bg p-relative right-bg"
                                // data-background="assets/img/breadcrumb/Homepage-slide.png"
                                style={{
                                  backgroundSize: "cover",
                                  backgroundImage:
                                    "url('assets/img/breadcrumb/Homepage-slide.png')",
                                }}
                              >
                                <div className="container-fluid">
                                  <div className="row align-items-center">
                                    <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12">
                                      <div className="tp-hero-2__main-thumb">
                                        <img
                                          src="assets/img/hero/head-image.png"
                                          alt=""
                                        />
                                      </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-4">
                                      <div className="tp-hero-2__left-box z-index">
                                        <div className="tp-hero-2__section-box mb-35">
                                          <h2
                                            className="tp-hero-2-title wow tpfadeUp"
                                            data-wow-duration=".9s"
                                            data-wow-delay=".5s"
                                            style={{
                                              visibility: "visible",
                                              animationDuration: "0.9s",
                                              animationDelay: "0.5s",
                                              animationName: "tpfadeUp",
                                            }}
                                          >
                                            Shoot. <br />
                                            <span className="p-relative">
                                              {" "}
                                              Upload. <br />
                                            </span>
                                            <span className="p-relative create">
                                              {" "}
                                              Create. <br />
                                            </span>
                                          </h2>
                                        </div>
                                        <div
                                          className="tp-hero-2__text wow tpfadeUp"
                                          data-wow-duration=".9s"
                                          data-wow-delay=".7s"
                                          style={{
                                            visibility: "visible",
                                            animationDuration: "0.9s",
                                            animationDelay: "0.7s",
                                            animationName: "tpfadeUp",
                                          }}
                                        >
                                          <h5 className="rate-main mb-10">
                                            #1 Rated App for printed photographs
                                            on{" "}
                                          </h5>
                                          <h4 className="heaD-heading">
                                            Canvas, Plexi, Wood
                                          </h4>
                                        </div>
                                        <div
                                          className="tp-hero-2__text-2 wow tpfadeUp"
                                          data-wow-duration=".9s"
                                          data-wow-delay=".7s"
                                          style={{
                                            visibility: "visible",
                                            animationDuration: "0.9s",
                                            animationDelay: "0.7s",
                                            animationName: "tpfadeUp",
                                          }}
                                        >
                                          {" "}
                                          <Link
                                            className="large head banner"
                                            to={"/create-custom-print"}
                                          >
                                            Start NOW
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="carousel-item">
                          <div className="tp-hero-2__wrapper fix p-relative">
                            <div className="tp-hero-2__area">
                              <div
                                className="tp-hero-2__bg p-relative right-bg"
                                // data-background="assets/img/breadcrumb/Homepage-slide.png"
                                style={{
                                  backgroundSize: "cover",
                                  backgroundImage:
                                    "url('assets/img/breadcrumb/Homepage-slide.png')",
                                }}
                              >
                                <div className="container-fluid">
                                  <div className="row align-items-center">
                                    <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12">
                                      <div className="tp-hero-2__main-thumb">
                                        <img
                                          src="assets/img/hero/head-image.png"
                                          alt=""
                                        />
                                      </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-4">
                                      <div className="tp-hero-2__left-box z-index">
                                        <div className="tp-hero-2__section-box mb-35">
                                          <h2
                                            className="tp-hero-2-title wow tpfadeUp"
                                            data-wow-duration=".9s"
                                            data-wow-delay=".5s"
                                            style={{
                                              visibility: "visible",
                                              animationDuration: "0.9s",
                                              animationDelay: "0.5s",
                                              animationName: "tpfadeUp",
                                            }}
                                          >
                                            Shoot. <br />
                                            <span className="p-relative">
                                              {" "}
                                              Upload. <br />
                                            </span>
                                            <span className="p-relative create">
                                              {" "}
                                              Create. <br />
                                            </span>
                                          </h2>
                                        </div>
                                        <div
                                          className="tp-hero-2__text wow tpfadeUp"
                                          data-wow-duration=".9s"
                                          data-wow-delay=".7s"
                                          style={{
                                            visibility: "visible",
                                            animationDuration: "0.9s",
                                            animationDelay: "0.7s",
                                            animationName: "tpfadeUp",
                                          }}
                                        >
                                          <h5 className="rate-main mb-10">
                                            #1 Rated App for printed photographs
                                            on{" "}
                                          </h5>
                                          <h4 className="heaD-heading">
                                            Canvas, Plexi, Wood
                                          </h4>
                                        </div>
                                        <div
                                          className="tp-hero-2__text-2 wow tpfadeUp"
                                          data-wow-duration=".9s"
                                          data-wow-delay=".7s"
                                          style={{
                                            visibility: "visible",
                                            animationDuration: "0.9s",
                                            animationDelay: "0.7s",
                                            animationName: "tpfadeUp",
                                          }}
                                        >
                                          {" "}
                                          <Link
                                            className="large head banner"
                                            to={"/create-custom-print"}
                                          >
                                            Start NOW
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="carousel-item active">
                          <div className="tp-hero-2__wrapper fix p-relative">
                            <div className="tp-hero-2__area">
                              <div className="tp-hero-2__bg p-relative right-bg">
                                <div className="container-fluid">
                                  <div className="row align-items-center">
                                    <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12">
                                      <div className="tp-hero-2__main-thumb">
                                        <img
                                          src="assets/img/hero/head-image.png"
                                          alt=""
                                        />
                                      </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-4">
                                      <div className="tp-hero-2__left-box z-index">
                                        <div className="tp-hero-2__section-box mb-35">
                                          <h2
                                            className="tp-hero-2-title wow tpfadeUp"
                                            data-wow-duration=".9s"
                                            data-wow-delay=".5s"
                                            style={{
                                              visibility: "visible",
                                              animationDuration: "0.9s",
                                              animationDelay: "0.5s",
                                              animationName: "tpfadeUp",
                                            }}
                                          >
                                            Shoot. <br />
                                            <span className="p-relative">
                                              {" "}
                                              Upload. <br />
                                            </span>
                                            <span className="p-relative create">
                                              {" "}
                                              Create. <br />
                                            </span>
                                          </h2>
                                        </div>
                                        <div
                                          className="tp-hero-2__text wow tpfadeUp"
                                          data-wow-duration=".9s"
                                          data-wow-delay=".7s"
                                          style={{
                                            visibility: "visible",
                                            animationDuration: "0.9s",
                                            animationDelay: "0.7s",
                                            animationName: "tpfadeUp",
                                          }}
                                        >
                                          <h5 className="rate-main mb-10">
                                            #1 Rated App for printed photographs
                                            on{" "}
                                          </h5>
                                          <h4 className="heaD-heading">
                                            Canvas, Plexi, Wood
                                          </h4>
                                        </div>
                                        <div
                                          className="tp-hero-2__text-2 wow tpfadeUp"
                                          data-wow-duration=".9s"
                                          data-wow-delay=".7s"
                                          style={{
                                            visibility: "visible",
                                            animationDuration: "0.9s",
                                            animationDelay: "0.7s",
                                            animationName: "tpfadeUp",
                                          }}
                                        >
                                          {" "}
                                          <Link
                                            className="large head banner"
                                            to={"/create-custom-print"}
                                          >
                                            Start NOW
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> 
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div className="tp-hero-2__wrapper fix p-relative">
          <div className="tp-hero-2__area">
            <div
              className="tp-hero-2__bg p-relative right-bg"
              style={{
                backgroundSize: "cover",
                backgroundImage:
                  "url('assets/img/breadcrumb/Homepage-slide.png')",
              }}
            >
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div
                      id="robotcarousel"
                      className="carousel slide"
                      data-bs-ride="carousel"
                    >
                      <div className="carousel-inner">
                        <div className="carousel-item active">
                          <div className="tp-hero-2__wrapper fix p-relative">
                            <div className="tp-hero-2__area">
                              <div className="tp-hero-2__bg p-relative right-bg">
                                <div className="container-fluid">
                                  <div className="row align-items-center">
                                    <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12">
                                      <div className="tp-hero-2__main-thumb">
                                        <img
                                          src="assets/img/hero/head-image.png"
                                          alt=""
                                        />
                                      </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-4">
                                      <div className="tp-hero-2__left-box z-index">
                                        <div className="tp-hero-2__section-box mb-35">
                                          <h2
                                            className="tp-hero-2-title wow tpfadeUp"
                                            data-wow-duration=".9s"
                                            data-wow-delay=".5s"
                                            style={{
                                              visibility: "visible",
                                              animationDuration: "0.9s",
                                              animationDelay: "0.5s",
                                              animationName: "tpfadeUp",
                                            }}
                                          >
                                            Shoot. <br />
                                            <span className="p-relative">
                                              {" "}
                                              Upload. <br />
                                            </span>
                                            <span className="p-relative create">
                                              {" "}
                                              Create. <br />
                                            </span>
                                          </h2>
                                        </div>
                                        <div
                                          className="tp-hero-2__text wow tpfadeUp"
                                          data-wow-duration=".9s"
                                          data-wow-delay=".7s"
                                          style={{
                                            visibility: "visible",
                                            animationDuration: "0.9s",
                                            animationDelay: "0.7s",
                                            animationName: "tpfadeUp",
                                          }}
                                        >
                                          <h5 className="rate-main mb-10">
                                            #1 Rated App for printed photographs
                                            on{" "}
                                          </h5>
                                          <h4 className="heaD-heading">
                                            Canvas, Plexi, Wood
                                          </h4>
                                        </div>
                                        <div
                                          className="tp-hero-2__text-2 wow tpfadeUp"
                                          data-wow-duration=".9s"
                                          data-wow-delay=".7s"
                                          style={{
                                            visibility: "visible",
                                            animationDuration: "0.9s",
                                            animationDelay: "0.7s",
                                            animationName: "tpfadeUp",
                                          }}
                                        >
                                          {" "}
                                          <Link
                                            className="large head banner"
                                            to={"/create-custom-print"}
                                          >
                                            Start NOW
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* hero-area-end */}
        {/* process-area-start */}

        <HomeProducts />

        {/* process-area-end */}
        {/* catagori-area-start */}
        <div
          className="tp-catagori-2__area p-relative"
          // data-background="assets/img/blog/index-2-bg.png"
          style={{
            backgroundSize: "cover",
            backgroundImage: "url('assets/img/blog/index-2-bg.png')",
          }}
        >
          <div className="container text-center pt-100 ">
            <div className="row text">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <h4 className="text-left second">
                  Why choose{" "}
                  <span className="color-inner">Printlific? </span>{" "}
                </h4>
                <p>
                  Your memories are our mission and at Printlific, we can help
                  you showcase <br /> them in the best way possible right in
                  your home.
                </p>
              </div>
            </div>
          </div>
          <div className="tp-catagori-2__wrapper-box p-relative pb-50">
            {/* <div class="tp-catagori-2__shape-2 d-none d-xxl-block">
              <img src="assets/img/catagori/shape-2-2.png" alt="">
          </div> */}
            <div className="container pb-50">
              <div className="row">
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                  <div className="tp-catagori-2__content-box mb-10">
                    <div className="tp-catagori-2__content plr text-center">
                      <img
                        className="w-32"
                        src="assets/img/blog/print_icon_1 1.png"
                        alt=""
                      />
                      <h4 className="tp-catagori-2__title text-white">
                        Turn your photos into a work of art
                      </h4>
                    </div>
                  </div>
                  <div className="bottom-para">
                    <p>
                      Transform your favorite memories into stunning canvas
                      prints that add warmth, personality, and style to any
                      space.
                    </p>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                  <div className="tp-catagori-2__content-box mb-10">
                    <div className="tp-catagori-2__content plr text-center">
                      <img
                        className="w-32"
                        src="assets/img/blog/print_icon_2 1.png"
                        alt=""
                      />
                      <h4 className="tp-catagori-2__title text-white">
                        Easy to customize with your choices
                      </h4>
                    </div>
                  </div>
                  <div className="bottom-para">
                    <p>
                      Choose from a variety of sizes, finishes, and framing
                      options to create a piece that's uniquely yours.
                    </p>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                  <div className="tp-catagori-2__content-box mb-10">
                    <div className="tp-catagori-2__content plr text-center">
                      <img
                        className="w-32"
                        src="assets/img/blog/print_icon_3 1.png"
                        alt=""
                      />
                      <h4 className="tp-catagori-2__title text-white">
                        Highest quality of materials and work
                      </h4>
                    </div>
                  </div>
                  <div className="bottom-para">
                    <p>
                      We use high-quality canvas, vibrant inks, and expert
                      craftsmanship to ensure every print looks beautiful for
                      years to come.
                    </p>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                  <div className="tp-catagori-2__content-box mb-10">
                    <div className="tp-catagori-2__content plr text-center">
                      <img
                        className="w-32"
                        src="assets/img/blog/print_icon_4 1.png"
                        alt=""
                      />
                      <h4 className="tp-catagori-2__title text-white">
                        Supporting you every step of the way
                      </h4>
                    </div>
                  </div>
                  <div className="bottom-para">
                    <p>
                      From placing your order to delivery, our team is here to
                      provide a smooth and hassle-free experience every step of
                      the way.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* catagori-area-end */}
        {/* full container start */}
        <section className="pt-0  full-section main">
          <div className="shaoes-manage">
            <div
              className="bg-over"
              data-background="assets/img/blog/index-2-bg-3.png"
              style={{
                backgroundImage: 'url("assets/img/blog/index-2-bg-3.png")',
              }}
            />
          </div>
          <div className="container">
            <div className="row ">
              <div className="col-xl-6 col-lg-6 col-md-12 p-0">
                <div className=" ">
                  <img
                    className="w-32"
                    src="assets/img/blog/printed-nature-photos-desert-landscape-in-shop-artisanhd 1.png"
                    alt=""
                  />
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 text p-0">
                <div className="bottom-para left pt-30 pb-30">
                  <h4>Immortalized on Plexi</h4>
                  <p>
                    Give your favorite photographs a sleek, modern look with
                    premium plexiglass prints. The crystal-clear acrylic finish
                    enhances color, depth, and detail, creating vibrant artwork
                    that's perfect for contemporary spaces.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-6 col-lg-6 col-md-12 text p-0">
                <div className="bottom-para left pt-30 pb-30">
                  <h4>Your story on Wood</h4>
                  <p>
                    Bring warmth and natural character to your memories with our
                    handcrafted wood prints. The unique wood grain adds rustic
                    charm, making every piece truly one of a kind.
                  </p>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 p-0">
                <div className=" ">
                  <img
                    className="w-32"
                    src="assets/img/blog/second-full.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-6 col-lg-6 col-md-12 p-0">
                <div className="image-top">
                  <img
                    className="w-32"
                    src="assets/img/blog/second-full-1.png"
                    alt=""
                  />
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 text p-0">
                <div className="bottom-para left pt-30 pb-30">
                  <h4>Art on Canvas</h4>
                  <p>
                    Transform your cherished moments into timeless canvas art
                    with rich colors, premium materials, and expert
                    craftsmanship. Designed to complement any home or office,
                    our canvas prints are made to be treasured for years to
                    come.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* full container end */}
        {/* Transforming your photographs into works of printed art start  */}
        <section className="parent">
          <section
            className=" pb-80 Partener photographs"
            style={{ backgroundSize: "cover" }}
          >
            <div className="container">
              <div className="row ">
                <div className="row text text-center pt-50">
                  <div className="col-xl-12 col-lg-12 col-md-12 text-center ">
                    <h4 className="text-left second">
                      Transforming your photographs <br /> into{" "}
                      <span className="color-inner">
                        works of printed art.
                      </span>{" "}
                    </h4>
                    <p className="">
                      Our mission is to transform your most memorable
                      photographs into works of canvas art. Our exceptional
                      customer service team will help you through our canvas,
                      retouching and framing options. Printlific sources the
                      best materials to create a professional product that you
                      will be proud to hang in your home.
                    </p>
                  </div>
                </div>
                <div
                  className="col-xl-8 col-lg-12 col-md-12 text-center m-auto pt-30"
                  style={{ zIndex: 9 }}
                >
                  <div className=" ">
                    <img
                      className="w-32"
                      src="assets/img/blog/shutterstock_2018794001 1.png"
                      alt=""
                    />
                  </div>
                </div>
                <div className="text-center mt-60 button-uper">
                  <Link
                    className="large head banner"
                    to={"/create-custom-print"}
                  >
                    Start NOW
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </section>
        {/* Transforming your photographs into works of printed art end  */}
        {/* client review start*/}
        <div
          className="tp-testimonial-5__area tp-testimonial-5__space  review"
          // data-background="assets/img/blog/our.png"
          style={{
            backgroundSize: "cover",
            backgroundImage: "url('assets/img/blog/our.png')",
          }}
        >
          <div className="container">
            <div className="row text text-center pt-50">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <h4 className="text-left second">
                  Our <span className="color-inner">customers.</span>{" "}
                </h4>
                <p>
                  Don’t just take our word for it - see what our satisfied
                  customers have to say about us!
                </p>
              </div>
            </div>

            <div className="row pb-50">
              <div className="col-xl-12">
                <div className="tp-testimonial-2__wrapper p-relative">
                  <div className="swiper-container tp-testimonial-2__active-2 swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events">
                    <Swiper
                      spaceBetween={40} // Customize this value as needed
                      slidesPerView={3} // Customize the number of slides displayed
                      modules={[Autoplay, Pagination]}
                      // navigation={true} // Enable navigation arrows
                      pagination={{ clickable: true }} // Enable pagination dots
                      loop={true} // Enable loop
                      autoplay={{ delay: 2000, disableOnInteraction: false }} // Autoplay with a 5-second delay
                      className="mySwiper" // Add any desired class name
                    >
                    <SwiperSlide>
  <div className="tp-testimonial-5__item p-relative">
    <div className="tp-testimonial-5__content p-relative text-center">
      <div className="tp-testimonial-5__star">
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
      </div>
      <p>
        "I ordered a canvas print of our wedding photo and it came out
        beautiful. The colors are exactly what I hoped for, and it looks
        amazing above our fireplace."
      </p>
      <h4 className="John-Doe">Amanda Wilson</h4>
    </div>
  </div>
</SwiperSlide>

<SwiperSlide>
  <div className="tp-testimonial-5__item p-relative">
    <div className="tp-testimonial-5__content p-relative text-center">
      <div className="tp-testimonial-5__star">
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
      </div>
      <p>
        "This was my first time ordering a custom print online, and I was
        honestly impressed. The quality is great and the packaging kept
        everything perfectly protected."
      </p>
      <h4 className="John-Doe">Jason Miller</h4>
    </div>
  </div>
</SwiperSlide>

<SwiperSlide>
  <div className="tp-testimonial-5__item p-relative">
    <div className="tp-testimonial-5__content p-relative text-center">
      <div className="tp-testimonial-5__star">
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
      </div>
      <p>
        "I bought a metallic print as a gift for my parents and they loved it.
        The finish gives the photo such a premium look compared to a regular
        frame."
      </p>
      <h4 className="John-Doe">Lauren Davis</h4>
    </div>
  </div>
</SwiperSlide>

<SwiperSlide>
  <div className="tp-testimonial-5__item p-relative">
    <div className="tp-testimonial-5__content p-relative text-center">
      <div className="tp-testimonial-5__star">
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
      </div>
      <p>
        "The canvas print turned out better than expected. It was easy to
        upload my photo, customize the size, and place the order. Definitely
        ordering again."
      </p>
      <h4 className="John-Doe">Ryan Thompson</h4>
    </div>
  </div>
</SwiperSlide>

<SwiperSlide>
  <div className="tp-testimonial-5__item p-relative">
    <div className="tp-testimonial-5__content p-relative text-center">
      <div className="tp-testimonial-5__star">
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
      </div>
      <p>
        "I was looking for something special for our new home and this was
        perfect. The print quality is excellent and the details look amazing."
      </p>
      <h4 className="John-Doe">Megan Carter</h4>
    </div>
  </div>
</SwiperSlide>

<SwiperSlide>
  <div className="tp-testimonial-5__item p-relative">
    <div className="tp-testimonial-5__content p-relative text-center">
      <div className="tp-testimonial-5__star">
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
        <i className="fa-solid fa-star" />
      </div>
      <p>
        "Great experience from start to finish. The customer service team was
        helpful and my print arrived exactly as expected."
      </p>
      <h4 className="John-Doe">Andrew Collins</h4>
    </div>
  </div>
</SwiperSlide>
                    </Swiper>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* client review end */}

        {/* Printlific Affiliate Partener section start */}
        <section className="pt-50 pb-80 Partener">
          <div className="container">
            <div className="row ">
              <div className="col-xl-6 col-lg-6 col-md-12">
                <div className=" ">
                  <img
                    className="w-32"
                    src="assets/img/blog/shutterstock_2192065237 2.png"
                    alt=""
                  />
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 text sec">
                <div className="bottom-para left pt-30 pb-30 ">
                  <h4>
                    Printlific Influencer <br /> Partner
                  </h4>
                  <p>
                    Partner with hundreds of influencers around the world. It is
                    free to join and easy to sign-up!
                  </p>
                </div>
                <div>
                  <Link className="large head banner" to={"/affiliateProgram"} >
                    Learn MORE
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Printlific Affiliate Partener section end */}

        <UpperFooterSlider />
      </main>
    </div>
  );
}
